import { Autocomplete, Box, Checkbox, Chip, Divider, FormControl, Grid, Icon, IconButton, InputLabel, ListItemText, MenuItem, Select, SelectChangeEvent, TextField, Tooltip, Typography } from "@mui/material";
import { CustomButton } from "components/roundedbutton/CustomButton";
import HeaderOuBannerDependendoDaInterpretacaoH1, { headerOuBannerDependendoDaInterpretacaoH1defaultFontSize } from "layout/header-ou-banner-dependendo-da-interpretacao-h1/HeaderOuBannerDependendoDaInterpretacaoH1";
import TopBarService from "layout/topbar/topbar.service";
import { getEmptyAbstractModel, IAbstractModel } from "model/abstract.model";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { ConfiguracoesChildrenProps } from "./Configuracoes";
import { ConfiguracoesTitle } from "./Configuracoes.model";

import CloseIcon from '@mui/icons-material/Close';
import DialogContext from "components/confirm-dialog-context";
import { useGenerateUuid } from "hooks/useGenerateUuid";
import { useSnackbarCustom } from "hooks/useSnackCustom";
import { ConfiguracaoPedidoBalcaoTO } from "layout/topbar/topBar.model";
import { CustomSwitch } from "pages/cadastro-pessoa/CadastroPessoa";
import CustomUserSettings from "pages/Venda/CustomUserSettings";
import CustomLoading from "pages/Venda/Header/CustomLoading";
import { setConfiguracaoPedidoBalcao } from "redux/features/configuracoes";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { theme } from "theme";
import { EntradaSaida, SimNao } from "utils/types";
import { isEmpty } from "utils/util";
import ConfiguracaoDescontoAcrescimoService from "./configuracao-desconto-acrescimo.service";

export enum TConfiguracaoPedidoBalcaoErros {
    TABELAS_DE_PRECO = "Tabelas de preço é um campo obrigatório.",
    TABELA_DE_PRECO = "Tabela de preço padrão é um campo obrigatório.",
    DEPOSITOS = "Depósitos é um campo obrigatório.",
    DEPOSITO = "Depósito padrão é um campo obrigatório.",
    MODELO_DOCUMENTO_FISCAL = "Modelo de documento fiscal padrão é um campo obrigatório.",
    SERIE_PADRAO_NFCE = "Série fiscal padrão para NFC-e (65) é um campo obrigatório.",
    SERIE_PADRAO_NFE = "Série fiscal padrão para NFE (55) é um campo obrigatório.",
}

export type TAcenumDTO = {
    codigo: string;
    descritivo: string;
    modelo: string;
    name: string;
    nome: string;
    nomeFiscal: string;
};

const initialState = {
    tabelasPreco: [] as Array<IAbstractModel>,
    tabelaPreco: getEmptyAbstractModel() as IAbstractModel,
    depositos: [] as Array<IAbstractModel>,
    deposito: getEmptyAbstractModel() as IAbstractModel,
    modeloDocumentoFiscal: { descritivo: "", name: "", codigo: "", modelo: "", nome: "", nomeFiscal: "" } as TAcenumDTO,
    serieFiscalNFCe: null as IAbstractModel | null,
    serieFiscalNFe: null as IAbstractModel | null,
    serieFiscalNFCeOutros: null as IAbstractModel | null,
    serieFiscalNFeOutros: null as IAbstractModel | null,
    tmfVenda: null as IAbstractModel | null,
    tmfDevolucao: null as IAbstractModel | null,
    tmfBrinde: null as IAbstractModel | null,
    somarValorBrindeTotalNota: true as boolean,
    tmfConsignado: null as IAbstractModel | null,
    tmfDevolucaoConsignado: null as IAbstractModel | null,
    tmfDevolucaoSimbolicaConsignado: null as IAbstractModel | null,
    tmfVendaConsignado: null as IAbstractModel | null,
    caixasObrigaVendedor: [] as Array<IAbstractModel>,
    cobranca: getEmptyAbstractModel() as IAbstractModel,

    options: {
        tabelasPreco: [] as Array<IAbstractModel>,
        depositos: [] as Array<IAbstractModel>,
        modeloDocumentosFicais: [] as Array<TAcenumDTO>,
        serieFiscalNFCe: [] as Array<IAbstractModel>,
        serieFiscalNFE: [] as Array<IAbstractModel>,
        tmfsVenda: [] as Array<IAbstractModel>,
        tmfsDevolucao: [] as Array<IAbstractModel>,
        tmfsBrinde: [] as Array<IAbstractModel>,
        caixasObrigaVendedor: [] as Array<IAbstractModel>
    },
    error: false as boolean,
    loading: true as boolean

};


const ConfigurarMovimentacaoFiscal = (props: ConfiguracoesChildrenProps) => {
    // const { caixaAberto } = useAppSelector(e => e.caixa.caixaAtual);
    const [stateLocal, setStateLocal] = useState(initialState);
    const topBarService = TopBarService();
    const configuracaoService = ConfiguracaoDescontoAcrescimoService();
    const isFirstRender = useRef<boolean>(true);
    const [randomUuid] = useGenerateUuid();
    const { addError, addSuccess } = useSnackbarCustom();
    const estabelecimentoSelecionado = useAppSelector(e => e.estabelecimentoSelecionado);
    const dispatch = useAppDispatch();
    const canClickRef = useRef<boolean>(true);
    const somarValorBrindeTotalNotaOriginalRef = useRef<boolean>(true);
    const dialog = useContext(DialogContext);

    const getEmptyIAbstract = useCallback(() => {
        return { descritivo: "", uuid: "" };
    }, []);

    const fetchData = useCallback(async () => {
        const configuracaoPedidoBalcao = await getConfiguracaoPedidoBalcao();
        somarValorBrindeTotalNotaOriginalRef.current = configuracaoPedidoBalcao?.somarValorBrindeTotalNota ?? true;
        setStateLocal(prevState => ({
            ...prevState,
            tabelasPreco: configuracaoPedidoBalcao?.tabelasPreco?.sort((a, b) => a.descritivo.localeCompare(b.descritivo)) ?? [],
            tabelaPreco: configuracaoPedidoBalcao?.tabelaPreco ?? getEmptyIAbstract(),
            depositos: configuracaoPedidoBalcao?.depositos ? sortDepositos(configuracaoPedidoBalcao?.depositos) : [],
            deposito: configuracaoPedidoBalcao?.deposito ?? getEmptyAbstractModel(),
            modeloDocumentoFiscal: configuracaoPedidoBalcao?.modeloDocumentoFiscal ?? { descritivo: '', name: '', codigo: "", modelo: "", nome: "", nomeFiscal: "" },
            serieFiscalNFCe: configuracaoPedidoBalcao?.serieFiscalNFCe ?? null,
            serieFiscalNFe: configuracaoPedidoBalcao?.serieFiscalNFe ?? null,
            serieFiscalNFCeOutros: configuracaoPedidoBalcao?.serieFiscalNFCeOutros ?? null,
            serieFiscalNFeOutros: configuracaoPedidoBalcao?.serieFiscalNFeOutros ?? null,
            tmfVenda: configuracaoPedidoBalcao?.tmfVenda ?? null,
            tmfDevolucao: configuracaoPedidoBalcao?.tmfDevolucao ?? null,
            tmfBrinde: configuracaoPedidoBalcao?.tmfBrinde ?? null,
            somarValorBrindeTotalNota: configuracaoPedidoBalcao?.somarValorBrindeTotalNota ?? true,
            caixasObrigaVendedor: configuracaoPedidoBalcao?.caixasObrigaVendedor ?? [],
        }));

        const tabelaPrecoOptions = await getTabelaPrecoOptions('');
        const depositosOptions = await getDepositoOptions();
        const modeloDocumentoFiscalOptions = await getModelosDocumentosFiscaisOptions();
        const serieFiscalNFCEOptions = await getSerieFiscalOptionByModeloFiscal("65");
        const serieFiscalNFEOptions = await getSerieFiscalOptionByModeloFiscal("55");
        const tmfsVenda = await getTmfOptions(EntradaSaida.SAIDA, "VENDA");
        const tmfsDevolucaoEntrada = await getTmfOptions(EntradaSaida.ENTRADA, "DEVOLUCAO");
        const tmfsDevolucaoSaida = await getTmfOptions(EntradaSaida.SAIDA, "DEVOLUCAO");
        const tmfsBrinde = await getTmfBrindeOptions();
        const caixasObrigaVendedor = await getCaixasObrigaVendedor();

        setStateLocal(prevstate => ({
            ...prevstate,
            options: {
                ...prevstate.options,
                tabelasPreco: tabelaPrecoOptions ?? [],
                depositos: depositosOptions ?? [],
                modeloDocumentosFicais: modeloDocumentoFiscalOptions ?? [],
                serieFiscalNFCe: serieFiscalNFCEOptions ?? [],
                serieFiscalNFE: serieFiscalNFEOptions ?? [],
                tmfsVenda: tmfsVenda ?? [],
                tmfsDevolucao: [...tmfsDevolucaoEntrada || [], ...tmfsDevolucaoSaida || []],
                tmfsBrinde: tmfsBrinde ?? [],
                caixasObrigaVendedor: caixasObrigaVendedor ?? []
            },
            loading: false
        }));
        //eslint-disable-next-line
    }, [estabelecimentoSelecionado.uuid]);



    useEffect(() => {
        if (!isFirstRender.current) {
            setStateLocal(prevState => ({ ...prevState, loading: true }));
            fetchData();
        }
        isFirstRender.current = false;
        //eslint-disable-next-line
    }, []);


    useEffect(() => {
        if (!isFirstRender.current) {
            setStateLocal(prevState => ({ ...prevState, loading: true }));
            fetchData();
        }
        isFirstRender.current = false;
        //eslint-disable-next-line
    }, [estabelecimentoSelecionado.uuid]);

    const getConfiguracaoPedidoBalcao = useCallback(async () => {
        try {
            const { data } = await topBarService.getConfiguracao();
            return data;
        } catch (err) {
            return undefined;
        }
        //eslint-disable-next-line
    }, [estabelecimentoSelecionado.uuid]);

    const getTabelaPrecoOptions = useCallback(async (toFilter: string) => {
        try {
            const { data } = await configuracaoService.getTabelasPrecoOptions(toFilter);
            return data;
        } catch (err) {
            return undefined;
        }
        //eslint-disable-next-line
    }, [estabelecimentoSelecionado.uuid]);

    const getDepositoOptions = useCallback(async () => {
        try {
            const { data } = await configuracaoService.getDepositosOptions();
            return data;
        } catch (err) {
            return undefined;
        }
        //eslint-disable-next-line
    }, [estabelecimentoSelecionado.uuid]);

    const getModelosDocumentosFiscaisOptions = useCallback(async () => {
        try {
            const { data } = await configuracaoService.getModelosDocumentosFiscaisOptions();
            return data;
        } catch (err) {
            return undefined;
        }
        //eslint-disable-next-line
    }, [estabelecimentoSelecionado.uuid]);

    const getSerieFiscalOptionByModeloFiscal = useCallback(async (modeloDocumentoFiscal: string) => {
        try {
            const { data } = await configuracaoService.getSerieFiscalOptionByModeloFiscal(modeloDocumentoFiscal);
            return data;
        } catch (err) {
            return undefined;
        }
        //eslint-disable-next-line
    }, [estabelecimentoSelecionado.uuid]);

    const getTmfOptions = useCallback(async (entradaSaida: EntradaSaida, nome: string) => {
        try {
            const { data } = await configuracaoService.getTmfOptions(entradaSaida, nome);
            return data;
        } catch (err) {
            return undefined;
        }
        //eslint-disable-next-line
    }, [estabelecimentoSelecionado.uuid]);


    const getTmfBrindeOptions = useCallback(async () => {
        try {
            const { data } = await configuracaoService.getTmfBrindeOptions();
            return data;
        } catch (err) {
            return undefined;
        }
        //eslint-disable-next-line
    }, [estabelecimentoSelecionado.uuid]);

    const getCaixasObrigaVendedor = useCallback(async () => {
        try {
            const { data } = await configuracaoService.getCaixasObrigaVendedor(SimNao.SIM);
            return data;
        } catch (err) {
            return undefined;
        }
        //eslint-disable-next-line
    }, [estabelecimentoSelecionado.uuid]);

    const isChecked = useCallback((array: Array<IAbstractModel>, item: IAbstractModel): boolean => {
        return array.some(e => e.uuid === item.uuid);
    }, []);

    const onClickItemTabelaPreco = useCallback((array: Array<IAbstractModel>, value: IAbstractModel) => {
        const isItemInArray = isChecked(array, value);

        const updatedArray = isItemInArray
            ? array.filter(e => e.uuid !== value.uuid)
            : [...array, value]
                .sort((a, b) => a.descritivo.localeCompare(b.descritivo));

        return setStateLocal(prevState => ({
            ...prevState,
            tabelasPreco: updatedArray,
            tabelaPreco: updatedArray.length === 1 ? updatedArray[0] : prevState.tabelaPreco
        }));
        //eslint-disable-next-line
    }, []);

    const onClickItemObrigaVendedor = useCallback((array: Array<IAbstractModel>, value: IAbstractModel) => {
        const isItemInArray = isChecked(array, value);

        const updatedArray = isItemInArray
            ? array.filter(e => e.uuid !== value.uuid)
            : [...array, value]
                .sort((a, b) => a.descritivo.localeCompare(b.descritivo));

        return setStateLocal(prevState => ({
            ...prevState,
            caixasObrigaVendedor: updatedArray
        }));
        //eslint-disable-next-line
    }, []);

    const onClickItemDeposito = useCallback((array: Array<IAbstractModel>, value: IAbstractModel) => {
        const isItemInArray = isChecked(array, value);

        const updatedArray = isItemInArray
            ? array.filter(e => e.uuid !== value.uuid)
            : [...array, value];

        return setStateLocal(prevState => ({
            ...prevState,
            depositos: sortDepositos(updatedArray),
            deposito: updatedArray.length === 1 ? updatedArray[0] : prevState.deposito
        }));
        //eslint-disable-next-line
    }, []);


    const onChangeTabelasPreco = useCallback((event: React.SyntheticEvent, value: string) => {
        if (event && event.type === "click") setStateLocal(prevState => ({ ...prevState, tabelasPreco: [], tabelaPreco: getEmptyAbstractModel() }));
        getTabelaPrecoOptions(value);
        //eslint-disable-next-line
    }, []);

    const onInputChangeDepositos = (event: React.SyntheticEvent) => {
        if (event && event.type === "click") setStateLocal(prevState => ({ ...prevState, depositos: [], deposito: getEmptyAbstractModel() }));
    };

    const onChangeCaixaObrigaVendedor = (event: React.SyntheticEvent) => {
        if (event && event.type === "click") setStateLocal(prevState => ({ ...prevState, caixasObrigaVendedor: [] }));
    };

    const renderOptionsTabelasPreco = useCallback((tabelasPreco: Array<IAbstractModel>, option: IAbstractModel) => {
        return (
            <MenuItem
                key={randomUuid()}
                value={option.descritivo}
                onClick={() => onClickItemTabelaPreco(tabelasPreco, option)}
            >
                <Checkbox
                    id={`item-${option.descritivo.toLowerCase()}-input`}
                    sx={{
                        '&.MuiCheckbox-root.Mui-checked': {
                            color: theme.palette.primary.main
                        }
                    }}
                    checked={isChecked(tabelasPreco, option)}
                />
                <ListItemText primary={option.descritivo} />
            </MenuItem>
        );
        //eslint-disable-next-line
    }, []);

    const renderOptionsDepositos = useCallback((depositos: Array<IAbstractModel>, option: IAbstractModel) => {
        return (
            <MenuItem
                key={randomUuid()}
                value={option.descritivo}
                onClick={() => onClickItemDeposito(depositos, option)}
            >
                <Checkbox
                    id={`item-${option.descritivo.toLowerCase()}-input`}
                    sx={{
                        '&.MuiCheckbox-root.Mui-checked': {
                            color: theme.palette.primary.main
                        }
                    }}
                    checked={isChecked(depositos, option)}
                />
                <ListItemText primary={option.descritivo} />
            </MenuItem>
        );
        //eslint-disable-next-line
    }, []);

    const handleTabelaChecksItem = useCallback((uuid: string, tabelasPreco: Array<IAbstractModel>) => {
        const found = tabelasPreco.find(e => e.uuid === uuid);

        if (found) {
            const tabelasRestantes = tabelasPreco.includes(found)
                ? tabelasPreco.filter(e => e.uuid !== uuid)
                : [...tabelasPreco, found];

            setStateLocal(prevState => ({
                ...prevState,
                tabelasPreco: tabelasRestantes,
                tabelaPreco: tabelasRestantes.length === 1 ? tabelasRestantes[0] : prevState.tabelaPreco?.uuid === uuid ? getEmptyIAbstract() : prevState.tabelaPreco
            }));
        }
        // eslint-disable-next-line
    }, []);

    const renderOptionsCaixaObrigavendedor = useCallback((caixasObrigaVendedor: Array<IAbstractModel>, option: IAbstractModel) => {
        return (
            <MenuItem
                key={randomUuid()}
                value={option.descritivo}
                onClick={() => onClickItemObrigaVendedor(caixasObrigaVendedor, option)}
            >
                <Checkbox
                    id={`item-${option.descritivo.toLowerCase()}-input`}
                    sx={{
                        '&.MuiCheckbox-root.Mui-checked': {
                            color: theme.palette.primary.main
                        }
                    }}
                    checked={isChecked(caixasObrigaVendedor, option)}
                />
                <ListItemText primary={option.descritivo} />
            </MenuItem>
        );
        //eslint-disable-next-line
    }, []);



    const handleDepositoChecksItem = useCallback((uuid: string, depositos: Array<IAbstractModel>) => {
        const found = depositos.find(e => e.uuid === uuid);

        if (found) {
            const depositosRestantes = depositos.includes(found)
                ? depositos.filter(e => e.uuid !== uuid)
                : [...depositos, found];

            setStateLocal(prevState => ({
                ...prevState,
                depositos: depositosRestantes,
                deposito: depositosRestantes.length === 1 ? depositosRestantes[0] : prevState.deposito?.uuid === uuid ? getEmptyAbstractModel() : prevState.deposito
            }));
        }
    }, []);

    const handleCaixasObrigaVendedorChecksItem = useCallback((uuid: string, caixasObrigaVendedor: Array<IAbstractModel>) => {
        const found = caixasObrigaVendedor.find(e => e.uuid === uuid);

        if (found) {
            const depositosRestantes = caixasObrigaVendedor.includes(found)
                ? caixasObrigaVendedor.filter(e => e.uuid !== uuid)
                : [...caixasObrigaVendedor, found];

            setStateLocal(prevState => ({
                ...prevState,
                caixasObrigaVendedor: depositosRestantes
            }));
        }
    }, []);

    const renderTagsTabelasPreco = useCallback((tabelasPreco: IAbstractModel[]) => {
        return (
            tabelasPreco.map(tabelaPreco => {
                return (
                    <Box
                        sx={{ backgroundColor: theme.palette.primary.main, color: theme.palette.background.default, borderRadius: '50px', marginRight: '5px', marginTop: '2px', marginBottom: '2px' }}
                    >
                        <Chip
                            key={tabelaPreco.uuid}
                            sx={{ height: '1.5rem', backgroundColor: theme.palette.primary.main, color: theme.palette.background.default }}
                            label={tabelaPreco.descritivo}
                        />
                        <IconButton
                            onClick={() => handleTabelaChecksItem(tabelaPreco.uuid, tabelasPreco)}
                            sx={{
                                color: theme.palette.background.default,
                                padding: 0,
                                paddingRight: "2px",
                                fontSize: '15px'
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                );
            })
        );
        //eslint-disable-next-line
    }, []);

    const renderTagsDepositos = useCallback((depositos: IAbstractModel[]) => {
        return (
            depositos.map(deposito => {
                return (
                    <Box
                        sx={{ backgroundColor: theme.palette.primary.main, color: theme.palette.background.default, borderRadius: '50px', marginRight: '5px', marginTop: '2px', marginBottom: '2px' }}
                    >
                        <Chip
                            key={deposito.uuid}
                            sx={{ height: '1.5rem', backgroundColor: theme.palette.primary.main, color: theme.palette.background.default }}
                            label={deposito.descritivo}
                        />
                        <IconButton
                            onClick={() => handleDepositoChecksItem(deposito.uuid, depositos)}
                            sx={{
                                color: theme.palette.background.default,
                                padding: 0,
                                paddingRight: "2px",
                                fontSize: '15px'
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                );
            })
        );
        //eslint-disable-next-line
    }, []);


    const renderTagsCaixaObrigaVendedor = useCallback((caixasObrigaVendedor: IAbstractModel[]) => {
        return (
            caixasObrigaVendedor.map(caixaObrigaVendedor => {
                return (
                    <Box
                        sx={{ backgroundColor: theme.palette.primary.main, color: theme.palette.background.default, borderRadius: '50px', marginRight: '5px', marginTop: '2px', marginBottom: '2px' }}
                    >
                        <Chip
                            key={caixaObrigaVendedor.uuid}
                            sx={{ height: '1.5rem', backgroundColor: theme.palette.primary.main, color: theme.palette.background.default }}
                            label={caixaObrigaVendedor.descritivo}
                        />
                        <IconButton
                            onClick={() => handleCaixasObrigaVendedorChecksItem(caixaObrigaVendedor.uuid, caixasObrigaVendedor)}
                            sx={{
                                color: theme.palette.background.default,
                                padding: 0,
                                paddingRight: "2px",
                                fontSize: '15px'
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                );
            })
        );
        //eslint-disable-next-line
    }, []);

    const onSelectTabelaPreco = useCallback((tabelasPreco: Array<IAbstractModel>, event: SelectChangeEvent<string>) => {
        const found = tabelasPreco.find(e => e.uuid === event.target.value);
        if (found) setStateLocal(prevState => ({ ...prevState, tabelaPreco: found }));
    }, []);

    const onSelectDeposito = useCallback((depositos: Array<IAbstractModel>, event: SelectChangeEvent<string>) => {
        const found = depositos.find(e => e.uuid === event.target.value);
        setStateLocal(prevState => ({ ...prevState, deposito: found! }));
    }, []);

    const onSelectModeloDocumentoFiscal = useCallback((modelosDocumentoFiscal: Array<TAcenumDTO>, event: SelectChangeEvent<string>) => {
        const found = modelosDocumentoFiscal.find(e => e.descritivo === event.target.value);
        if (found) setStateLocal(prevState => ({
            ...prevState,
            modeloDocumentoFiscal: { descritivo: found.descritivo, name: found.name, codigo: found.codigo, modelo: found.modelo, nome: found.nome, nomeFiscal: found.nomeFiscal }
        }));
    }, []);

    const onSelectSerie = useCallback((state: string, options: Array<IAbstractModel>, event: SelectChangeEvent<string>) => {
        const found = options.find(e => e.uuid === event.target.value);
        if (found) setStateLocal(prevState => ({ ...prevState, [state]: found }));
    }, []);

    const onSelectTmf = useCallback((state: string, options: Array<IAbstractModel>, event: SelectChangeEvent<string>) => {
        const found = options.find(e => e.uuid === event.target.value);
        if (found) setStateLocal(prevState => ({ ...prevState, [state]: found }));
    }, []);

    const sortDepositos = useCallback((depositos: Array<IAbstractModel>) => {
        if (depositos.every(e => e.id !== undefined)) {
            return depositos.sort((a, b) => a.id! - b.id!);
        }
        return depositos;
    }, []);

    const renderValue = useCallback((array: Array<IAbstractModel>, uuid: string) => {
        return array.find(e => e.uuid === uuid)?.descritivo;
    }, []);

    const renderValueModeloFiscal = useCallback((array: Array<TAcenumDTO>, descritivo: string) => {
        return array.find(e => e.descritivo === descritivo)?.descritivo;
    }, []);

    const resetModeloDocumentoFiscal = useCallback(() => {
        setStateLocal(prevState => ({ ...prevState, modeloDocumentoFiscal: initialState.modeloDocumentoFiscal }));
    }, []);

    const resetSerieFiscalNFCE = useCallback(() => {
        setStateLocal(prevState => ({ ...prevState, serieFiscalNFCe: initialState.serieFiscalNFCe }));
    }, []);


    const resetSerieFiscalNFE = useCallback(() => {
        setStateLocal(prevState => ({ ...prevState, serieFiscalNFe: initialState.serieFiscalNFe }));
    }, []);


    const resetSerieFiscalNFEOutros = useCallback(() => {
        setStateLocal(prevState => ({ ...prevState, serieFiscalNFeOutros: initialState.serieFiscalNFeOutros }));
    }, []);


    const resetSerieFiscalNFCEOutros = useCallback(() => {
        setStateLocal(prevState => ({ ...prevState, serieFiscalNFCeOutros: initialState.serieFiscalNFeOutros }));
    }, []);

    const resetTmfVenda = useCallback(() => {
        setStateLocal(prevState => ({ ...prevState, tmfVenda: initialState.tmfVenda }));
    }, []);

    const resetTmfDevolucao = useCallback(() => {
        setStateLocal(prevState => ({ ...prevState, tmfDevolucao: initialState.tmfDevolucao }));
    }, []);

    const resetTmfBrinde = useCallback(() => {
        setStateLocal(prevState => ({ ...prevState, tmfBrinde: initialState.tmfBrinde }));
    }, []);

    const handleChangeSomarValorBrindeTotalNota = useCallback((checked: boolean) => {
        setStateLocal(prevState => ({ ...prevState, somarValorBrindeTotalNota: checked }));
    }, []);

    const enviarConfiguracao = async (configuracaoPedidoBalcaoTO: ConfiguracaoPedidoBalcaoTO) => {
        try {
            const { data } = await configuracaoService.updateConfiguracaoPedidoBalcao(configuracaoPedidoBalcaoTO);
            if (data) {
                canClickRef.current = true;
                dispatch(setConfiguracaoPedidoBalcao(configuracaoPedidoBalcaoTO));
                addSuccess({ message: "Configuração pedido balcao atualizada com sucesso.", persist: false, id: "erro_atualicao_pedido_balcao", preventDuplicate: true, hideDuration: 5000 });
                props.onGoBack();
            }
        } catch (err) {
            canClickRef.current = true;
            addError({ message: "Ocorreu um erro inesperado. Se o erro persistir, entre em contato com o suporte." });
        }
    };

    const salvar = async () => {
        if (!canClickRef.current) return;
        canClickRef.current = false;
        let hasError = false;
        if (isEmpty(stateLocal.tabelasPreco)) {
            hasError = true;
            addError({
                message: TConfiguracaoPedidoBalcaoErros.TABELAS_DE_PRECO,
                closeable: true,
                preventDuplicate: true,
                id: TConfiguracaoPedidoBalcaoErros.TABELAS_DE_PRECO
            });
        }
        if (stateLocal.tabelasPreco.length > 1 && (!stateLocal.tabelaPreco.descritivo && !stateLocal.tabelaPreco.uuid)) {
            hasError = true;
            addError({
                message: TConfiguracaoPedidoBalcaoErros.TABELA_DE_PRECO,
                closeable: true,
                preventDuplicate: true,
                id: TConfiguracaoPedidoBalcaoErros.TABELA_DE_PRECO
            });
        }
        if (isEmpty(stateLocal.depositos)) {
            hasError = true;
            addError({
                message: TConfiguracaoPedidoBalcaoErros.DEPOSITOS,
                closeable: true,
                preventDuplicate: true,
                id: TConfiguracaoPedidoBalcaoErros.DEPOSITOS
            });
        }
        if (!stateLocal.modeloDocumentoFiscal.codigo) {
            hasError = true;
            addError({
                message: TConfiguracaoPedidoBalcaoErros.MODELO_DOCUMENTO_FISCAL,
                closeable: true,
                preventDuplicate: true,
                id: TConfiguracaoPedidoBalcaoErros.MODELO_DOCUMENTO_FISCAL
            });
        }
        if (stateLocal.modeloDocumentoFiscal.codigo === "55" && !stateLocal.serieFiscalNFe?.uuid) {
            hasError = true;
            addError({
                message: TConfiguracaoPedidoBalcaoErros.SERIE_PADRAO_NFE,
                closeable: true,
                preventDuplicate: true,
                id: TConfiguracaoPedidoBalcaoErros.SERIE_PADRAO_NFE
            });
        }
        if (stateLocal.modeloDocumentoFiscal.codigo === "65" && !stateLocal.serieFiscalNFCe?.uuid) {
            hasError = true;
            addError({
                message: TConfiguracaoPedidoBalcaoErros.SERIE_PADRAO_NFCE,
                closeable: true,
                preventDuplicate: true,
                id: TConfiguracaoPedidoBalcaoErros.SERIE_PADRAO_NFCE
            });
        }
        if (hasError) {
            canClickRef.current = true;
            return setStateLocal(prevState => ({ ...prevState, error: true }));
        }


        const configuracaoPedidoBalcaoTO: ConfiguracaoPedidoBalcaoTO = {

            tabelasPreco: stateLocal.tabelasPreco,
            depositos: stateLocal.depositos,
            modeloDocumentoFiscal: stateLocal.modeloDocumentoFiscal,
            serieFiscalNFCe: stateLocal.serieFiscalNFCe,
            serieFiscalNFe: stateLocal.serieFiscalNFe,
            serieFiscalNFCeOutros: stateLocal.serieFiscalNFCeOutros,
            serieFiscalNFeOutros: stateLocal.serieFiscalNFeOutros,
            tmfVenda: stateLocal.tmfVenda,
            tmfDevolucao: stateLocal.tmfDevolucao,
            tmfBrinde: stateLocal.tmfBrinde,
            somarValorBrindeTotalNota: stateLocal.somarValorBrindeTotalNota,
            caixasObrigaVendedor: stateLocal.caixasObrigaVendedor,
            tabelaPreco: stateLocal.tabelaPreco,
            tabelaPrecoPadrao: stateLocal.tabelaPreco,
            deposito: stateLocal.deposito,
        };

        const estaDesativandoSomarValorBrinde = !stateLocal.somarValorBrindeTotalNota && somarValorBrindeTotalNotaOriginalRef.current;

        if (estaDesativandoSomarValorBrinde) {
            return dialog.confirm({
                title: 'Desativar envio do valor do brinde?',
                message: (
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        <Typography>Ao desativar esta configuração, os produtos marcados como brinde serão enviados no XML com valor de R$ 0,00 e não serão somados ao valor total da nota fiscal.</Typography>
                        <Typography>A aceitação desse procedimento pode variar conforme a legislação de cada estado. Antes de continuar, confirme a orientação com sua contabilidade ou verifique a legislação aplicável ao estabelecimento emissor.</Typography>
                        <Typography>Deseja realmente desativar esta configuração?</Typography>
                    </Box>
                ),
                onConfirm: () => enviarConfiguracao(configuracaoPedidoBalcaoTO),
                onCancel: () => { canClickRef.current = true; },
            });
        }

        await enviarConfiguracao(configuracaoPedidoBalcaoTO);
    };

    return (
        <>
            <Box
                sx={{
                    overflow: "hidden",
                    width: '100%',
                    '& .actions': {
                        color: 'text.secondary',
                    },
                    '& .textPrimary': {
                        color: 'text.primary',
                    },
                }}
            >
                <HeaderOuBannerDependendoDaInterpretacaoH1
                    id='configuracoes-desconto'
                    customIcon={
                        <CustomUserSettings
                            id="custom_hand_holding_dollar_icon_configuracoes"
                            color={theme.palette.text.primary}
                            fontSize={headerOuBannerDependendoDaInterpretacaoH1defaultFontSize.normal}
                            style={{ marginBottom: '5px' }}
                        />
                    }
                    label={ConfiguracoesTitle.MOVIMENTACOES_FISCAIS}
                />

                <Grid item xs={12} >
                    <Typography
                        sx={{
                            fontSize: 22,
                            marginBottom: '10px'
                        }}
                    >
                        Configurar pedido balcão
                    </Typography>
                    <Divider />
                </Grid>

                <Grid sx={{
                    height: 520,
                    overflowY: 'auto',
                    marginTop: '20px'
                }}>
                    {!stateLocal.loading &&
                        <>
                            <FormControl fullWidth variant="standard" error={isEmpty(stateLocal.tabelasPreco)}>
                                <Autocomplete sx={{
                                    width: '50%',
                                }}
                                    renderTags={renderTagsTabelasPreco}
                                    value={stateLocal.tabelasPreco}
                                    multiple
                                    id="acTabelaPreco"
                                    options={stateLocal.options.tabelasPreco}
                                    getOptionLabel={(option) => option.descritivo}
                                    onInputChange={onChangeTabelasPreco}
                                    noOptionsText={'Nenhum resultado encontrado'}
                                    isOptionEqualToValue={(option, value) => option.uuid === value.uuid}

                                    renderInput={
                                        (params) => <TextField
                                            {...params}
                                            label="Tabelas de preço *"
                                            variant="standard"
                                            error={isEmpty(stateLocal.tabelasPreco)}
                                        />}
                                    renderOption={(_, option) => renderOptionsTabelasPreco(stateLocal.tabelasPreco, option)}
                                />
                                {isEmpty(stateLocal.tabelasPreco) &&
                                    <Typography sx={{
                                        color: theme.palette.error.main,
                                        marginTop: '5px'
                                    }}>
                                        {TConfiguracaoPedidoBalcaoErros.TABELAS_DE_PRECO}
                                    </Typography>
                                }
                            </FormControl>

                            {stateLocal.tabelasPreco.length > 1 &&
                                <FormControl fullWidth variant="standard" error={!stateLocal.tabelaPreco.uuid} sx={{
                                    marginTop: '20px'
                                }}>
                                    <InputLabel id="tipo-pessoa-label" htmlFor="tipo-pessoa-input">Tabela de preço padrão * </InputLabel>
                                    <Select sx={{
                                        width: '50%'
                                    }}
                                        id="tipo-pessoa-component"
                                        inputProps={{ id: 'tipo-pessoa-input' }}
                                        value={stateLocal.tabelaPreco?.uuid ?? ""}
                                        renderValue={(uuid) => renderValue(stateLocal.options.tabelasPreco, uuid)}
                                        onChange={(e) => onSelectTabelaPreco(stateLocal.tabelasPreco, e)}
                                        style={{ color: theme.palette.text.primary }}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 48 * 4.5 + 8,
                                                    width: 100
                                                },
                                            },
                                        }}
                                    >
                                        {stateLocal.tabelasPreco.map(tp => (
                                            <MenuItem
                                                key={tp.uuid}
                                                value={tp.uuid}
                                            >
                                                {tp.descritivo}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    {!stateLocal.tabelaPreco.uuid &&
                                        <Typography sx={{
                                            color: theme.palette.error.main
                                        }}>
                                            {TConfiguracaoPedidoBalcaoErros.TABELA_DE_PRECO}
                                        </Typography>
                                    }
                                </FormControl>
                            }

                            <FormControl fullWidth variant="standard" error={isEmpty(stateLocal.depositos)}>
                                <Autocomplete sx={{
                                    marginTop: '20px',
                                    width: '50%',
                                }}
                                    renderTags={renderTagsDepositos}
                                    value={stateLocal.depositos}
                                    multiple
                                    id="acDeposito"
                                    options={stateLocal.options.depositos}
                                    getOptionLabel={(option) => option.descritivo}
                                    onInputChange={onInputChangeDepositos}
                                    noOptionsText={'Nenhum resultado encontrado'}
                                    isOptionEqualToValue={(option, value) => option.uuid === value.uuid}
                                    renderInput={
                                        (params) => <TextField
                                            {...params}
                                            label="Depósitos *"
                                            variant="standard"
                                            error={isEmpty(stateLocal.depositos)}
                                        />}
                                    renderOption={(_, option) => renderOptionsDepositos(stateLocal.depositos, option)}
                                />
                                {isEmpty(stateLocal.depositos) &&
                                    <Typography sx={{
                                        color: theme.palette.error.main,
                                        marginTop: '5px'
                                    }}>
                                        {TConfiguracaoPedidoBalcaoErros.DEPOSITOS}
                                    </Typography>
                                }
                            </FormControl>

                            {stateLocal.depositos.length > 1 &&
                                <FormControl fullWidth variant="standard" error={!stateLocal.deposito.uuid} sx={{
                                    marginTop: '20px'
                                }}>
                                    <InputLabel id="tipo-pessoa-label" htmlFor="tipo-pessoa-input">Depósito padrão *</InputLabel>
                                    <Select sx={{
                                        width: '50%'
                                    }}
                                        id="tipo-pessoa-component"
                                        inputProps={{ id: 'tipo-pessoa-input' }}
                                        value={stateLocal.deposito?.uuid ?? ""}
                                        renderValue={(uuid) => renderValue(stateLocal.options.depositos, uuid)}
                                        onChange={(e) => onSelectDeposito(stateLocal.depositos, e)}
                                        style={{ color: theme.palette.text.primary }}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 48 * 4.5 + 8,
                                                    width: 100
                                                },
                                            },
                                        }}
                                    >
                                        {stateLocal.depositos.map(deposito => (
                                            <MenuItem
                                                key={deposito.uuid}
                                                value={deposito.uuid}
                                            >
                                                {deposito.descritivo}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    {(!stateLocal.deposito.uuid) &&
                                        <Typography sx={{
                                            color: theme.palette.error.main
                                        }}>
                                            {TConfiguracaoPedidoBalcaoErros.DEPOSITO}
                                        </Typography>
                                    }
                                </FormControl>
                            }

                            <FormControl fullWidth variant="standard" error={!stateLocal.modeloDocumentoFiscal.codigo} sx={{
                                marginTop: '20px'
                            }}>
                                <InputLabel id="tipo-pessoa-label" htmlFor="tipo-pessoa-input">Modelo de documento fiscal padrão *</InputLabel>
                                <Select sx={{
                                    width: '50%',
                                }}
                                    id="tipo-pessoa-component"
                                    inputProps={{ id: 'tipo-pessoa-input' }}
                                    value={stateLocal.options.modeloDocumentosFicais.length > 0 ? stateLocal.modeloDocumentoFiscal.descritivo : ""}
                                    renderValue={(descritivo) => renderValueModeloFiscal(stateLocal.options.modeloDocumentosFicais, descritivo)}
                                    onChange={(e) => onSelectModeloDocumentoFiscal(stateLocal.options.modeloDocumentosFicais, e)}
                                    style={{
                                        color: theme.palette.text.primary,
                                        position: 'relative'

                                    }}
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                maxHeight: 48 * 4.5 + 8,
                                                width: 100
                                            },
                                        },
                                    }}
                                >
                                    {stateLocal.options.modeloDocumentosFicais.map(mdf => (
                                        <MenuItem
                                            key={randomUuid()}
                                            value={mdf.descritivo}
                                        >
                                            {mdf.descritivo}
                                        </MenuItem>
                                    ))}
                                </Select>
                                <IconButton
                                    onClick={resetModeloDocumentoFiscal}
                                    sx={{
                                        position: 'absolute',
                                        left: "46.2%",
                                        top: 5,
                                        color: (theme) => theme.palette.grey[700],
                                    }}
                                >
                                    <CloseIcon sx={{ fontSize: "20px" }} />
                                </IconButton>
                                {!stateLocal.modeloDocumentoFiscal.codigo &&
                                    <Typography sx={{
                                        color: theme.palette.error.main,
                                        marginTop: '5px'
                                    }}>
                                        {TConfiguracaoPedidoBalcaoErros.MODELO_DOCUMENTO_FISCAL}
                                    </Typography>
                                }
                            </FormControl>

                            <FormControl fullWidth variant="standard" error={false} sx={{
                                marginTop: '20px'
                            }}>
                                <InputLabel id="tipo-pessoa-label"
                                    htmlFor="tipo-pessoa-input"
                                    error={stateLocal.modeloDocumentoFiscal.codigo === "65" && !stateLocal.serieFiscalNFCe?.uuid}
                                >
                                    Série fiscal padrão para NFC-e (65){stateLocal.modeloDocumentoFiscal.codigo === "65" ? "*" : ""}
                                </InputLabel>
                                <Select sx={{
                                    width: '50%'
                                }}
                                    id="tipo-pessoa-component"
                                    inputProps={{ id: 'tipo-pessoa-input' }}
                                    value={stateLocal.options.serieFiscalNFCe.length > 0 ? stateLocal.serieFiscalNFCe?.uuid : ""}
                                    renderValue={(uuid) => renderValue(stateLocal.options.serieFiscalNFCe, uuid)}
                                    onChange={(e) => onSelectSerie("serieFiscalNFCe", stateLocal.options.serieFiscalNFCe, e)}
                                    style={{ color: theme.palette.text.primary }}
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                maxHeight: 48 * 4.5 + 8,
                                                width: 100
                                            },
                                        },
                                    }}
                                >
                                    {stateLocal.options.serieFiscalNFCe.map(serieNfce => (
                                        <MenuItem
                                            key={serieNfce.uuid}
                                            value={serieNfce.uuid}
                                        >
                                            {serieNfce.descritivo}
                                        </MenuItem>
                                    ))}
                                </Select>
                                {stateLocal.modeloDocumentoFiscal.codigo === "65" && !stateLocal.serieFiscalNFCe?.uuid &&
                                    <Typography sx={{
                                        color: theme.palette.error.main
                                    }}>
                                        {TConfiguracaoPedidoBalcaoErros.SERIE_PADRAO_NFCE}
                                    </Typography>
                                }
                                {stateLocal.serieFiscalNFCe &&
                                    <IconButton
                                        onClick={resetSerieFiscalNFCE}
                                        sx={{
                                            position: 'absolute',
                                            left: "46.2%",
                                            top: 5,
                                            color: (theme) => theme.palette.grey[700],
                                        }}
                                    >
                                        <CloseIcon sx={{ fontSize: "20px" }} />
                                    </IconButton>
                                }
                            </FormControl>

                            <FormControl fullWidth variant="standard" error={false} sx={{
                                marginTop: '20px'
                            }}>
                                <InputLabel
                                    id="tipo-pessoa-label"
                                    htmlFor="tipo-pessoa-input"
                                    error={stateLocal.modeloDocumentoFiscal.codigo === "55" && !stateLocal.serieFiscalNFe?.uuid}
                                >
                                    Série fiscal padrão para NFE (55) {stateLocal.modeloDocumentoFiscal.codigo === "55" ? "*" : ""}
                                </InputLabel>
                                <Select sx={{
                                    width: '50%'
                                }}
                                    id="tipo-pessoa-component"
                                    inputProps={{ id: 'tipo-pessoa-input' }}
                                    value={stateLocal.options.serieFiscalNFE.length > 0 ? stateLocal.serieFiscalNFe?.uuid : ""}
                                    renderValue={(uuid) => renderValue(stateLocal.options.serieFiscalNFE, uuid)}
                                    onChange={(e) => onSelectSerie("serieFiscalNFe", stateLocal.options.serieFiscalNFE, e)}
                                    style={{ color: theme.palette.text.primary }}
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                maxHeight: 48 * 4.5 + 8,
                                                width: 100
                                            },
                                        },
                                    }}
                                >
                                    {stateLocal.options.serieFiscalNFE.map(serieNfce => (
                                        <MenuItem
                                            key={serieNfce.uuid}
                                            value={serieNfce.uuid}
                                        >
                                            {serieNfce.descritivo}
                                        </MenuItem>
                                    ))}
                                </Select>
                                {stateLocal.modeloDocumentoFiscal.codigo === "55" && !stateLocal.serieFiscalNFe?.uuid &&
                                    <Typography sx={{
                                        color: theme.palette.error.main
                                    }}>
                                        {TConfiguracaoPedidoBalcaoErros.SERIE_PADRAO_NFCE}
                                    </Typography>
                                }
                                {stateLocal.serieFiscalNFe &&
                                    <IconButton
                                        onClick={resetSerieFiscalNFE}
                                        sx={{
                                            position: 'absolute',
                                            left: "46.2%",
                                            top: 5,
                                            color: (theme) => theme.palette.grey[700],
                                        }}
                                    >
                                        <CloseIcon sx={{ fontSize: "20px" }} />
                                    </IconButton>
                                }
                            </FormControl>

                            <FormControl fullWidth variant="standard" error={false} sx={{
                                marginTop: '20px'
                            }}>
                                <InputLabel id="tipo-pessoa-label" htmlFor="tipo-pessoa-input">Série fiscal padrão para outros (65)</InputLabel>
                                <Select sx={{
                                    width: '50%'
                                }}
                                    id="tipo-pessoa-component"
                                    inputProps={{ id: 'tipo-pessoa-input' }}
                                    value={stateLocal.options.serieFiscalNFCe.length > 0 ? stateLocal.serieFiscalNFCeOutros?.uuid : ""}
                                    renderValue={(uuid) => renderValue(stateLocal.options.serieFiscalNFCe, uuid)}
                                    onChange={(e) => onSelectSerie("serieFiscalNFCeOutros", stateLocal.options.serieFiscalNFCe, e)}
                                    style={{ color: theme.palette.text.primary }}
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                maxHeight: 48 * 4.5 + 8,
                                                width: 100
                                            },
                                        },
                                    }}
                                >
                                    {stateLocal.options.serieFiscalNFCe.map(serieNfce => (
                                        <MenuItem
                                            key={serieNfce.uuid}
                                            value={serieNfce.uuid}
                                        >
                                            {serieNfce.descritivo}
                                        </MenuItem>
                                    ))}
                                </Select>
                                {stateLocal.serieFiscalNFCeOutros &&
                                    <IconButton
                                        onClick={resetSerieFiscalNFCEOutros}
                                        sx={{
                                            position: 'absolute',
                                            left: "46.2%",
                                            top: 5,
                                            color: (theme) => theme.palette.grey[700]
                                        }}
                                    >
                                        <CloseIcon sx={{ fontSize: "20px" }} />
                                    </IconButton>
                                }
                            </FormControl>

                            <FormControl fullWidth variant="standard" error={false} sx={{
                                marginTop: '20px'
                            }}>
                                <InputLabel id="tipo-pessoa-label" htmlFor="tipo-pessoa-input">Série fiscal padrão para outros (55)</InputLabel>
                                <Select sx={{
                                    width: '50%'
                                }}
                                    id="tipo-pessoa-component"
                                    inputProps={{ id: 'tipo-pessoa-input' }}
                                    value={stateLocal.options.serieFiscalNFE.length > 0 ? stateLocal.serieFiscalNFeOutros?.uuid : ""}
                                    renderValue={(uuid) => renderValue(stateLocal.options.serieFiscalNFE, uuid)}
                                    onChange={(e) => onSelectSerie("serieFiscalNFeOutros", stateLocal.options.serieFiscalNFE, e)}
                                    style={{ color: theme.palette.text.primary }}
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                maxHeight: 48 * 4.5 + 8,
                                                width: 100
                                            },
                                        },
                                    }}
                                >
                                    {stateLocal.options.serieFiscalNFE.map(serieNfce => (
                                        <MenuItem
                                            key={serieNfce.uuid}
                                            value={serieNfce.uuid}
                                        >
                                            {serieNfce.descritivo}
                                        </MenuItem>
                                    ))}
                                </Select>
                                {stateLocal.serieFiscalNFeOutros &&
                                    <IconButton
                                        onClick={resetSerieFiscalNFEOutros}
                                        sx={{
                                            position: 'absolute',
                                            left: "46.2%",
                                            top: 5,
                                            color: (theme) => theme.palette.grey[700]
                                        }}
                                    >
                                        <CloseIcon sx={{ fontSize: "20px" }} />
                                    </IconButton>
                                }
                            </FormControl>

                            <FormControl fullWidth variant="standard" error={false} sx={{
                                marginTop: '20px'
                            }}>
                                <InputLabel id="tipo-pessoa-label" htmlFor="tipo-pessoa-input">Tipo de movimento Fiscal - Venda</InputLabel>
                                <Select sx={{
                                    width: '50%'
                                }}
                                    id="tipo-pessoa-component"
                                    inputProps={{ id: 'tipo-pessoa-input' }}
                                    value={stateLocal.tmfVenda?.uuid ?? ""}
                                    renderValue={(uuid) => renderValue(stateLocal.options.tmfsVenda, uuid)}
                                    onChange={(e) => onSelectTmf("tmfVenda", stateLocal.options.tmfsVenda, e)}
                                    style={{ color: theme.palette.text.primary }}
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                maxHeight: 48 * 4.5 + 8,
                                                width: 100
                                            },
                                        },
                                    }}
                                >
                                    {stateLocal.options.tmfsVenda.map(tmfVenda => (
                                        <MenuItem
                                            key={tmfVenda.uuid}
                                            value={tmfVenda.uuid}
                                        >
                                            {tmfVenda.descritivo}
                                        </MenuItem>
                                    ))}
                                </Select>
                                {stateLocal.tmfVenda &&
                                    <IconButton
                                        onClick={resetTmfVenda}
                                        sx={{
                                            position: 'absolute',
                                            left: "46.2%",
                                            top: 5,
                                            color: (theme) => theme.palette.grey[700]
                                        }}
                                    >
                                        <CloseIcon sx={{ fontSize: "20px" }} />
                                    </IconButton>
                                }

                            </FormControl>

                            <FormControl fullWidth variant="standard" error={false} sx={{
                                marginTop: '20px'
                            }}>
                                <InputLabel id="tipo-pessoa-label" htmlFor="tipo-pessoa-input">Tipo de Movimento Fiscal - Devolução</InputLabel>
                                <Select sx={{
                                    width: '50%'
                                }}
                                    id="tipo-pessoa-component"
                                    inputProps={{ id: 'tipo-pessoa-input' }}
                                    value={stateLocal.tmfDevolucao?.uuid ?? ""}
                                    renderValue={(uuid) => renderValue(stateLocal.options.tmfsDevolucao, uuid)}
                                    onChange={(e) => onSelectTmf("tmfDevolucao", stateLocal.options.tmfsDevolucao, e)}
                                    style={{ color: theme.palette.text.primary }}
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                maxHeight: 48 * 4.5 + 8,
                                                width: 100
                                            },
                                        },
                                    }}
                                >
                                    {stateLocal.options.tmfsDevolucao.map(tmfVenda => (
                                        <MenuItem
                                            key={tmfVenda.uuid}
                                            value={tmfVenda.uuid}
                                        >
                                            {tmfVenda.descritivo}
                                        </MenuItem>
                                    ))}
                                </Select>
                                {stateLocal.tmfDevolucao &&
                                    <IconButton
                                        onClick={resetTmfDevolucao}
                                        sx={{
                                            position: 'absolute',
                                            left: "46.2%",
                                            top: 5,
                                            color: (theme) => theme.palette.grey[700]
                                        }}
                                    >
                                        <CloseIcon sx={{ fontSize: "20px" }} />
                                    </IconButton>
                                }

                            </FormControl>


                            <FormControl fullWidth variant="standard" error={false} sx={{
                                marginTop: '20px'
                            }}>
                                <InputLabel id="tipo-pessoa-label" htmlFor="tipo-pessoa-input">Tipo de Movimento Fiscal - Brinde</InputLabel>
                                <Select sx={{
                                    width: '50%'
                                }}
                                    id="tipo-pessoa-component"
                                    inputProps={{ id: 'tipo-pessoa-input' }}
                                    value={stateLocal.tmfBrinde?.uuid ?? ""}
                                    renderValue={(uuid) => renderValue(stateLocal.options.tmfsBrinde, uuid)}
                                    onChange={(e) => onSelectTmf("tmfBrinde", stateLocal.options.tmfsBrinde, e)}
                                    style={{ color: theme.palette.text.primary }}
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                maxHeight: 48 * 4.5 + 8,
                                                width: 100
                                            },
                                        },
                                    }}
                                >
                                    {stateLocal.options.tmfsBrinde.map(tmfVenda => (
                                        <MenuItem
                                            key={tmfVenda.uuid}
                                            value={tmfVenda.uuid}
                                        >
                                            {tmfVenda.descritivo}
                                        </MenuItem>
                                    ))}
                                </Select>
                                {stateLocal.tmfBrinde &&
                                    <IconButton
                                        onClick={resetTmfBrinde}
                                        sx={{
                                            position: 'absolute',
                                            left: "46.2%",
                                            top: 5,
                                            color: (theme) => theme.palette.grey[700]
                                        }}
                                    >
                                        <CloseIcon sx={{ fontSize: "20px" }} />
                                    </IconButton>
                                }
                                <Tooltip
                                    title={<Typography> Para que o valor do produto não seja incluído no valor total da venda, o Tipo de movimentação fiscal(TMF) tem que estar configurada para não gerar financeiro!</Typography>}>
                                    <Icon className="fa-solid fa-circle-info" fontSize="medium" sx={{ position: "absolute", right: "47.2%", top: "15px", padding: 1 }} />
                                </Tooltip>
                            </FormControl>

                            <Box
                                sx={{
                                    display: 'flex',
                                    width: '50%',
                                    justifyContent: 'space-between',
                                    marginTop: '20px'
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontSize: 18,
                                        color: theme.palette.text.primary
                                    }}
                                >
                                    Somar valor do brinde ao total da nota?
                                </Typography>

                                <CustomSwitch
                                    id='somar-valor-brinde-total-nota-input'
                                    checked={stateLocal.somarValorBrindeTotalNota}
                                    onChange={(_, checked) => handleChangeSomarValorBrindeTotalNota(checked)}
                                    name="somar-valor-brinde-total-nota" />
                            </Box>

                            <FormControl fullWidth variant="standard" error={true}>
                                <Autocomplete sx={{
                                    width: '50%',
                                    marginTop: '20px',
                                    marginBottom: "40px"
                                }}
                                    renderTags={renderTagsCaixaObrigaVendedor}
                                    value={stateLocal.caixasObrigaVendedor}
                                    multiple
                                    id="acTabelaPreco"
                                    options={stateLocal.options.caixasObrigaVendedor}
                                    getOptionLabel={(option) => option.descritivo}
                                    onInputChange={onChangeCaixaObrigaVendedor}
                                    noOptionsText={'Nenhum resultado encontrado'}
                                    isOptionEqualToValue={(option, value) => option.uuid === value.uuid}

                                    renderInput={
                                        (params) => <TextField
                                            {...params}
                                            label="Obriga informar vendedor para os caixas"
                                            variant="standard"
                                        />}
                                    renderOption={(_, option) => renderOptionsCaixaObrigavendedor(stateLocal.caixasObrigaVendedor, option)}
                                />
                            </FormControl>
                        </>
                    }
                </Grid>
            </Box>

            <Grid
                sx={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-end',
                    marginTop: '50px'
                }}
            >
                <CustomButton
                    sx={{ minWidth: '80px' }}
                    id="voltar-configuracao-vale-presente-btn"
                    onClick={props.onGoBack}
                    variant="contained"
                    color="error"
                    startIcon={<Icon className='fa-solid fa-arrow-left' />}>
                    Voltar
                </CustomButton>

                <CustomButton
                    sx={{ minWidth: '80px' }}
                    id="voltar-configuracao-vale-presente-btn"
                    onClick={salvar}
                    variant="contained"
                    color="success"
                    startIcon={<Icon className='fa-solid fa-check' />}>
                    Salvar
                </CustomButton>
            </Grid>

            {stateLocal.loading &&
                <CustomLoading />
            }
        </>
    );
};

export default ConfigurarMovimentacaoFiscal;
